var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forum__foot"},[_c('ul',{staticClass:"pagination"},[(_vm.prev === 0)?_c('li',{staticClass:"pagination__item prev disabled"},[_vm._v("Prev")]):_c('li',{staticClass:"pagination__item prev"},[_c('router-link',{attrs:{"to":{
					name: _vm.baseUrl,
					query: {
						limit: _vm.limit,
						offset: _vm.offset(_vm.prev - 1)
					}
				}}},[_vm._v("Prev")])],1),_vm._l((_vm.pageArray),function(page){return _c('li',{key:page,staticClass:"pagination__item",class:{active: _vm.current === page }},[(_vm.current !== page)?_c('router-link',{attrs:{"to":{
					name: _vm.baseUrl,
					query: {
						limit: _vm.limit,
						offset: _vm.offset(page - 1)
					}
				}}},[_vm._v("\n\t\t\t\t"+_vm._s(page)+"\n\t\t\t")]):_c('span',{staticClass:"current"},[_vm._v(_vm._s(page)+"\n\t\t\t")])],1)}),(_vm.current === _vm.endIndex)?_c('li',{staticClass:"pagination__item prev disabled"},[_vm._v("\n\t\t\tNext\n\t\t")]):_c('li',{staticClass:"pagination__item next"},[_c('router-link',{attrs:{"to":{
					name: _vm.baseUrl,
					query: {
						limit: _vm.limit,
						offset: _vm.offset(_vm.next - 1)
					}
				}}},[_vm._v("\n\t\t\t\tNext\n\t\t\t")])],1)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }